export default __webpack_public_path__ + "static/media/logo.2109bb36.png";